import * as React from 'react';
import { WebGivingMerchant, MerchantCardPreference } from '../../webgiving-generated';
import { Text } from '../../components/text';

export class PagePaymentMethodSupportedDescription extends React.Component<{ merchant: WebGivingMerchant, supportsCard: boolean, supportsApplepay: boolean }, {}> {
	render() {
		const { merchant: { CardPreference, TradingName, SupportsAch, PaymentLabel }, supportsCard, supportsApplepay } = this.props;
		let supportedDescription: string = '';

		if (SupportsAch) {
			if (supportsCard) {
				switch (CardPreference) {
					case MerchantCardPreference.AnyCard:
						supportedDescription = supportsApplepay ?
							"accepts Apple Pay, debit cards, credit cards and bank transfers."
							: "accepts debit cards, credit cards and bank transfers.";
						break;
					case MerchantCardPreference.DebitPreferred:
						supportedDescription = supportsApplepay ?
							`prefers debit cards or bank transfers for ${PaymentLabel.VerbPresentTenseLowerCase} but also accepts Apple Pay and other supported cards.`
							: `prefers debit cards or bank transfers for ${PaymentLabel.VerbPresentTenseLowerCase} but also accepts other supported cards.`;
						break;
					case MerchantCardPreference.DebitOnly:
						supportedDescription = supportsApplepay ?
							"accepts Apple Pay, debit cards and bank transfers only."
							: "accepts debit cards and bank transfers only.";
						break;
				}
			} else {
				supportedDescription = 'accepts bank transfers only.';
			}
		} else {
			switch (CardPreference) {
				case MerchantCardPreference.AnyCard:
					supportedDescription = supportsApplepay ?
						'accepts Apple Pay, debit cards and credit cards.'
						: 'accepts debit cards and credit cards.';
					break;
				case MerchantCardPreference.DebitPreferred:
					supportedDescription = supportsApplepay ?
						`prefers debit cards for ${PaymentLabel.VerbPresentTenseLowerCase} but also accepts Apple Pay and other supported cards.`
						: `prefers debit cards for ${PaymentLabel.VerbPresentTenseLowerCase} but also accepts other supported cards.`;
					break;
				case MerchantCardPreference.DebitOnly:
					supportedDescription = supportsApplepay ?
						`only accepts Apple Pay and debit cards for ${PaymentLabel.VerbPresentTenseLowerCase}.`
						: `only accepts debit cards for ${PaymentLabel.VerbPresentTenseLowerCase}.`;
					break;
			}
		}

		return <span>{TradingName} <Text>{supportedDescription}</Text></span>;
	}
}
